export { SpiderWebContainer } from "./spiderweb-container";
export {
    clientPointToSpiderWebPercent,
    effectiveLeadingImagePlacement,
    getFillColor,
    getRectangleBorderRadius,
    leadingInsideIconSidePx,
    LEADING_ICON_INSIDE_GAP_RATIO,
    LEADING_ICON_OUTSIDE_GAP_RATIO,
    LEADING_INSIDE_EXTRA_WIDTH_RATIO,
    LEADING_INSIDE_ICON_EM_SCALE,
    VIEWBOX_SCALE
} from "./spiderweb-utils";
export {
    computeDocumentSectionScrollProgress,
    getNearestVerticalScrollContainer,
    useSpiderwebDocumentSectionProgress
} from "./use-spiderweb-document-section-progress";
export {
    directionNearestScrollMagnetProgress,
    forwardBiasedScrollMagnetProgress,
    normalizeScrollMagnetAnchors,
    useSpiderwebScrollMagnet
} from "./use-spiderweb-scroll-magnet";
export type { UseSpiderwebScrollMagnetOptions } from "./use-spiderweb-scroll-magnet";
export {
    animationPhasesUseScrollWindows,
    scrollWindowPhase
} from "./scroll-window-phases";
export type { ScrollWindowPhaseTarget } from "./scroll-window-phases";
export {
    ANIMATION_PHASES_SCROLL_TIMELINE_UNITS_DEFAULT,
    usableColors
} from "./spiderweb-types";
export type {
    AnimationPhase,
    AnimationPhasesDrive,
    SpiderWebCanvasClickPct,
    SpiderWebContainerProps,
    SpiderWebNodeFocus,
    SpiderWebNodeFocusVariant,
    WebNodeConfig,
    WebConnectorConfig,
    ConnectorBias,
    NodeShape,
    NodeImagePlacement,
    ConnectorShape,
    ConnectorType,
    AnimationColor,
    FillColor,
    SpiderWebNodeBorderColor,
    ModalContent,
    OverlapFill,
    WebNodeOverlapConfig
} from "./spiderweb-types";
export { AnimatedModal } from "@/components/adg4/animated-modal/src";
export type {
    AnimatedModalContent,
    AnimatedModalProps
} from "@/components/adg4/animated-modal/src";
